import { render, staticRenderFns } from "./SPIFPdfIntroduction.vue?vue&type=template&id=3f48e00f"
import script from "./SPIFPdfIntroduction.vue?vue&type=script&lang=js"
export * from "./SPIFPdfIntroduction.vue?vue&type=script&lang=js"
import style0 from "./SPIFPdfIntroduction.vue?vue&type=style&index=0&id=3f48e00f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports